export const locale = {
  deviceEntity: '端末',
  device: {
    id: '管理No.',
    label: '画面名',
    memo: 'メモ',
    clients: 'クライアント',
    category: '端末タイプ',
  },
  clientEntity: 'クライアント',
  client: {
    devices: '利用製品',
    name: '名前',
    memo: 'メモ',
    email: 'メールアドレス',
    allowIntegration: 'データ連携',
    allowIntegrationP1: 'データ',
    allowIntegrationP2: '連携',
    allowSurfaceTemp: '温度表示',
    allowDialGauge: 'ダイヤルゲージ接続',
    allowMailNotify: 'アラートメール通知',
    allowDownload: 'データダウンロード',
    allowDownloadP1: 'データ',
    allowDownloadP2: 'ダウンロード',
    createdAt: '登録日',
    contactStartDate: '契約開始日',
    contactEndDate: '契約終了日',
    updatedAt: '変更日',
    password: 'パスワード',
    company: '会社名',
  },
} as const
